export default function not(a) {
  return !a;
}
